/**
 * WB4 Phase 3 — shared registry lookup for palette intent proposal resolution.
 */

import type { WorkbenchCommandContext } from './command-resolver';
import type { WorkbenchFocus } from './workbench-focus';
import { resolveFocusIntent, resolveWorkbenchActions } from './workbench-kernel';
import type { WorkbenchResolvedAction } from './workbench-kernel';

export function resolveRegistryActionsForPaletteContext(
  ctx: WorkbenchCommandContext
): WorkbenchResolvedAction[] {
  if (!ctx.object) {
    return [];
  }

  const businessDomain = ctx.businessDomain ?? String(ctx.object.businessDomain ?? 'entity');
  const status = ctx.status ?? String(ctx.object.status);
  const focus: WorkbenchFocus =
    ctx.focus ??
    ({
      root: {
        id: ctx.object.id,
        businessDomain,
        ...(ctx.object.name ? { label: ctx.object.name } : {}),
      },
      selection: [],
      intent: resolveFocusIntent({
        role: ctx.role,
        status,
        plane: ctx.plane,
        permissionKeys: ctx.permissionKeys,
      }),
      mode: 'view',
      variant: 'object',
      actionProjection: 'commandPalette',
    } as WorkbenchFocus);

  return resolveWorkbenchActions(
    ctx.object,
    {
      role: ctx.role,
      plane: ctx.plane,
      permissionKeys: ctx.permissionKeys,
      surface: 'command',
      businessDomain,
      status,
      focus,
    },
    { permissionKeys: ctx.permissionKeys }
  );
}
